module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-0f759a.bec5877d.png";